import type { Resolvers } from 'owa-graph-schema';
import type * as lazyFunctions from './lazyFunctions';
import { LazyBootModule, LazyImport } from 'owa-bundling-light';

const lazyModule: LazyBootModule<typeof lazyFunctions> = new LazyBootModule<typeof lazyFunctions>(
    () => import(/* webpackChunkName: "DataWorkerPstResolvers" */ './lazyFunctions'),
    { name: 'DataWorkerPstResolvers' }
);

export const lazyPstResolvers: LazyImport<
    Promise<Resolvers>,
    LazyBootModule<typeof lazyFunctions>
> = new LazyImport(lazyModule, m => m.lazyPstResolvers.import());
